module.exports = __webpack_public_path__ + "img/D201508_7.61d71f00.jpg";